var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-row',{staticClass:"py-5",attrs:{"justify":"center"}},[_c('v-col',{staticClass:"pa-0",attrs:{"cols":"12","sm":"10","md":"8","lg":"6","xl":"4"}},[_c('AccountList')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }